/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiSessionEffectivenessConditionPayloadFromJSON, ApiSessionEffectivenessConditionPayloadToJSON, } from './ApiSessionEffectivenessConditionPayload';
export function ApiSessionEffectivenessConditionGroupPayloadFromJSON(json) {
    return ApiSessionEffectivenessConditionGroupPayloadFromJSONTyped(json, false);
}
export function ApiSessionEffectivenessConditionGroupPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'conditions': !exists(json, 'conditions') ? undefined : (json['conditions'].map(ApiSessionEffectivenessConditionPayloadFromJSON)),
    };
}
export function ApiSessionEffectivenessConditionGroupPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'conditions': value.conditions === undefined ? undefined : (value.conditions.map(ApiSessionEffectivenessConditionPayloadToJSON)),
    };
}
